import React, { useState, useEffect } from 'react';
import { messageNotification } from 'helpers';
import { Form } from 'react-bootstrap';
import { getEdlySiteConfig, updateEdlySiteConfig, updateWpSiteConfig } from 'services/siteConfiguration';

const PublicRegistration = () => {
  const [disablePublicRegistration, setDisablePublicRegistration] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getEdlySiteConfig().then((res) => {
      setDisablePublicRegistration(
        res.data.lms?.FEATURES?.ALLOW_PUBLIC_ACCOUNT_CREATION !== undefined
          ? !res.data.lms.FEATURES.ALLOW_PUBLIC_ACCOUNT_CREATION
          : false
      );
    });
  }, []);

  const togglePublicRegistration = () => {
    const originalState = disablePublicRegistration;
    setDisablePublicRegistration(!originalState);

    setIsLoading(true);
    const lms_json_data = {
      lms: {
        FEATURES: {
          ALLOW_PUBLIC_ACCOUNT_CREATION: disablePublicRegistration
        },
        MFE_CONFIG: {
          ALLOW_PUBLIC_ACCOUNT_CREATION: disablePublicRegistration
        }
      }
    };

    const wp_json_data = {
      toggle_reg_btn: `${disablePublicRegistration}`
    };
    updateWpSiteConfig(wp_json_data)
      .then((res) => {
        !disablePublicRegistration &&
          messageNotification(
            'success',
            'Public registration toggled on',
            'Public registration toggled on for marketing site'
          );

        disablePublicRegistration &&
          messageNotification(
            'success',
            'Public registration toggled off',
            'Public registration toggled off for marketing site'
          );
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
        setIsLoading(false);
        setDisablePublicRegistration(originalState);
      });

    updateEdlySiteConfig(lms_json_data)
      .then((res) => {
        !disablePublicRegistration &&
          messageNotification(
            'success',
            'Public registration toggled on',
            'Public registration toggled on for LMS site'
          );

        disablePublicRegistration &&
          messageNotification(
            'success',
            'Public registration toggled off',
            'Public registration toggled off for LMS site'
          );
        setIsLoading(false);
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
        setIsLoading(false);
        setDisablePublicRegistration(originalState);
      });
  };
  return (
    <div className="subheader-holder">
      <h4>Public Registration</h4>
      <p>
        Disabling public registration will not allow users to self-register. If disabled then the standard registration
        form on '/register' URL is disabled and the register button is removed from the site header
      </p>

      <div className="custom-control custom-checkbox" style={{ justifyContent: 'inherit' }}>
        <Form.Check
          label="Disable public registration"
          id="publicRegistration"
          type="checkbox"
          onChange={togglePublicRegistration}
          checked={disablePublicRegistration}
        />
        {isLoading && (
          <small className="text-muted ms-2 d-flex align-items-center">
            <span className="spinner-border me-1" role="status" style={{ width: '0.75rem', height: '0.75rem' }}></span>
            Saving...
          </small>
        )}
      </div>
    </div>
  );
};

export default PublicRegistration;
